import request from './request';

export const httpGet = <T>(url: string): Promise<T> => request<T>(url, { method: 'GET' });
